import { render, staticRenderFns } from "./CardQa.vue?vue&type=template&id=59ed4e90"
import script from "./CardQa.vue?vue&type=script&lang=js"
export * from "./CardQa.vue?vue&type=script&lang=js"
import style0 from "./CardQa.vue?vue&type=style&index=0&id=59ed4e90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports